import { has } from 'lodash';
import { AnyEventObject } from 'xstate';
import {
  BuyServiceEvent,
  CalculateServiceEvent,
  ChangeRouteEvent,
  CreateServiceEvent,
  ErrorPlatformEvent,
  MetaDataServiceEvent,
  NextData,
  NextQuoteEvent,
  QuoteServiceEvent,
  RateServiceEvent,
} from './events.types';

export function isNextQuoteEvent(event: AnyEventObject): event is NextQuoteEvent {
  return has(event.data, 'submission') || has(event.data, 'digitalSubmission');
}

export function isSaveDataEvent(event: AnyEventObject): event is { type: 'SAVE_DATA'; data: Partial<NextData> } {
  return has(event, 'data');
}

export function isChangeRouteEvent(event: AnyEventObject): event is ChangeRouteEvent {
  return has(event.data, 'routePath');
}

export function isRateServiceEvent(event: AnyEventObject): event is RateServiceEvent {
  return has(event.data, 'ratings');
}

export function isMetaDataServiceEvent(event: AnyEventObject): event is MetaDataServiceEvent {
  return has(event.data, 'coverageDictionary') || has(event.data, 'variantDictionary');
}

export function isCalculateServiceEvent(event: AnyEventObject): event is CalculateServiceEvent {
  return has(event.data, 'variants');
}

export function isCreateServiceEvent(event: AnyEventObject): event is CreateServiceEvent {
  return has(event.data, 'data');
}

export function isQuoteServiceEvent(event: AnyEventObject): event is QuoteServiceEvent {
  return has(event.data, 'data') && has(event.data, 'ids');
}

export function isBuyServiceEvent(event: AnyEventObject): event is BuyServiceEvent {
  return has(event.data, 'paymentUrl');
}

export function isErrorPlatformEvent(event: AnyEventObject): event is ErrorPlatformEvent {
  return has(event.data, 'message');
}
